<mat-expansion-panel [expanded]="autoExpand">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'reportTemplateID'" [placeholder]="'common.labels.report' | transloco">
          @for (template of _reportTemplates; track template) {
            <mat-option [value]="template.id">
              {{ template.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateRequestedFrom' | transloco }}</mat-label>
        <input matInput [matDatepicker]="addedFrom" [formControlName]="'addedFrom'"
          [placeholder]="'common.labels.dateRequestedFrom' | transloco">
        <mat-datepicker-toggle matSuffix [for]="addedFrom"></mat-datepicker-toggle>
        <mat-datepicker #addedFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateRequestedTo' | transloco }}</mat-label>
        <input matInput [matDatepicker]="addedTo" [formControlName]="'addedTo'"
          [placeholder]="'common.labels.dateRequestedTo' | transloco">
        <mat-datepicker-toggle matSuffix [for]="addedTo"></mat-datepicker-toggle>
        <mat-datepicker #addedTo></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="spacer-small"></div>

    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>